import ToolbarController from "./toolbar.controller";

const ToolbarDirective = {
    template:require("./toolbar.template.html"),
    controller:ToolbarController,
    bindToController:true,
    controllerAs:'$ctrl',
    restrict:'A'

};

export default ToolbarDirective;


// WEBPACK FOOTER //
// ./public/app/toolbar/toolbar.directive.js